import { authenticatedFetch } from './authService';

// Include session creation and body parsing in the deadline, so a broken request
// always leaves the spinner and reaches the existing retry screen.
export async function fetchStockAvailability(url, ids, { request = authenticatedFetch, timeoutMs = 45000 } = {}) {
  const controller = new AbortController();
  let timer;
  try {
    return await Promise.race([
      (async () => {
        const response = await request(url, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ storeIds: ids }), signal: controller.signal,
        });
        if (!response.ok) throw new Error('Availability request failed');
        const data = await response.json();
        if (!Array.isArray(data.storesWithStock) || data.status === 'partial' || data.unknownStoreIds?.length ||
            data.storesWithStock.some(id => !ids.includes(id))) {
          throw new Error('Product availability could not be verified');
        }
        return data.storesWithStock;
      })(),
      new Promise((_, reject) => {
        timer = setTimeout(() => {
          controller.abort();
          reject(new Error('Product availability timed out'));
        }, timeoutMs);
      }),
    ]);
  } finally {
    clearTimeout(timer);
  }
}
